<template>
  <header :class="['header', { 'header--transparent': isTransparent, 'header--scrolled': scrolled }]">
    <div class="nav-inner">
      <div class="brand" @click="goHome" role="button" aria-label="返回首页">
        <div class="brand-logo-wrap">
          <img src="/logo.png" alt="Logo" class="brand-logo" />
        </div>
        <div class="brand-text">
          <div class="brand-name">中政量化研究院</div>
          <div class="brand-slogan">科 技 驱 动 量 化 投 资</div>
        </div>
      </div>
      
      <nav class="main-nav" :class="{ 'mobile-nav-open': mobileMenuOpen }" aria-label="主导航">
        <ul>
          <li><router-link to="/" exact @click="closeMobileMenu">首页</router-link></li>
          <li><router-link to="/about" @click="closeMobileMenu">关于我们</router-link></li>
          <li><router-link to="/products" @click="closeMobileMenu">产品服务</router-link></li>
          <li><router-link to="/research" @click="closeMobileMenu">专家团队</router-link></li>
          <li><router-link to="/news" @click="closeMobileMenu">新闻资讯</router-link></li>
        </ul>
      </nav>
      
      <button class="mobile-menu-toggle" @click="toggleMobileMenu" :class="{ 'is-active': mobileMenuOpen }" aria-label="菜单">
        <span></span>
        <span></span>
        <span></span>
      </button>
    </div>
  </header>
</template>

<script>
export default {
  name: 'HeaderComponent',
  data(){
    return {
      isTransparent:true, 
      scrolled:false,
      mobileMenuOpen:false
    };
  },
  watch:{
    '$route.path': { immediate:true, handler(){ this.evaluateState(); this.closeMobileMenu(); } }
  },
  mounted(){
    window.addEventListener('scroll', this.onScroll, { passive:true });
    this.evaluateState();
  },
  beforeDestroy(){ 
    window.removeEventListener('scroll', this.onScroll); 
  },
  methods: {
    goHome() {
      if (this.$route.path !== '/') {
        this.$router.push('/').catch(err => {
          if (err.name !== 'NavigationDuplicated') {
            console.error('导航错误:', err);
          }
        });
      }
    },
    onScroll(){
      const y = window.scrollY || window.pageYOffset;
      this.scrolled = y > 10;
      this.evaluateState();
    },
    evaluateState(){
      const onHome = this.$route.path === '/';
      const y = window.scrollY || window.pageYOffset;
      const threshold = window.innerHeight * 0.7;
      this.isTransparent = onHome && y < threshold;
    },
    toggleMobileMenu() {
      this.mobileMenuOpen = !this.mobileMenuOpen;
    },
    closeMobileMenu() {
      this.mobileMenuOpen = false;
    }
  }
}
</script>

<style scoped>
.header { width:100%; position:fixed; top:0; left:0; z-index:1000; background:transparent; transition:background .35s, box-shadow .35s; }
.header--transparent { background:transparent; box-shadow:none; }
.header:not(.header--transparent){ background:rgba(255,255,255,0.95); backdrop-filter:saturate(180%) blur(12px); box-shadow:0 1px 4px rgba(0,0,0,.06); }
.header--transparent .main-nav a, .header--transparent .brand-name, .header--transparent .brand-slogan { color:#fff; }
.header--transparent .main-nav a::after { background:#fff; }
.header--scrolled:not(.header--transparent) { box-shadow:0 4px 22px -4px rgba(0,0,0,.12); }

.nav-inner { 
  width: 100%; 
  max-width: 1400px; 
  margin: 0 auto; 
  padding: 0 32px; 
  height: 74px; 
  display: flex; 
  align-items: center; 
  justify-content: space-between; 
  box-sizing: border-box;
}

.brand { 
  display: flex; 
  align-items: center; 
  cursor: pointer; 
  user-select: none; 
  flex-shrink: 0;
}

.brand-logo-wrap { 
  width: 56px; 
  height: 56px; 
  display: flex; 
  align-items: center; 
  justify-content: center; 
  overflow: visible; 
}

.brand-logo { 
  max-width: 90%; 
  max-height: 90%; 
  width: auto; 
  height: auto; 
  object-fit: contain; 
  transform: none; 
  display: block;
}

.brand-text { 
  line-height: 1.1; 
  display: flex; 
  flex-direction: column; 
  margin-left: 16px; 
  min-width: 0;
}

.brand-name { 
  font-size: 22px; 
  font-weight: 700; 
  letter-spacing: 1.5px; 
  color: inherit; 
  white-space: nowrap;
}

.brand-slogan { 
  font-size: 10px; 
  margin-top: 3px; 
  letter-spacing: 4px; 
  white-space: nowrap; 
  opacity: 0.8; 
  color: inherit;
}

.main-nav { 
  flex: 1; 
  display: flex; 
  align-items: center; 
  justify-content: center; 
  margin: 0 40px;
}
.main-nav ul { 
  list-style: none; 
  padding: 0; 
  margin: 0; 
  display: flex; 
  align-items: center; 
  justify-content: center; 
  gap: 48px; 
  flex-wrap: nowrap;
}

.main-nav a { 
  position: relative; 
  display: inline-block; 
  padding: 12px 0; 
  font-size: 15px; 
  font-weight: 500; 
  letter-spacing: 0.5px; 
  text-decoration: none; 
  transition: all 0.3s ease; 
  color: #304156; 
  text-shadow: 0 1px 2px rgba(0,0,0,0.05);
  white-space: nowrap;
}

.main-nav a::after { 
  content: ""; 
  position: absolute; 
  left: 0; 
  bottom: 2px; 
  height: 2px; 
  width: 0; 
  background: #1890ff; 
  transition: width 0.3s ease;
}
.main-nav a.router-link-exact-active::after, .main-nav a:hover::after { width:100%; }

/* 移动端菜单按钮 */
.mobile-menu-toggle {
  display: none;
  flex-direction: column;
  justify-content: space-around;
  width: 30px;
  height: 24px;
  background: transparent;
  border: none;
  cursor: pointer;
  padding: 0;
  z-index: 1001;
}

.mobile-menu-toggle span {
  width: 100%;
  height: 2px;
  background: #304156;
  border-radius: 2px;
  transition: all 0.3s ease;
}

.header--transparent .mobile-menu-toggle span {
  background: #fff;
}

.mobile-menu-toggle.is-active span:nth-child(1) {
  transform: rotate(45deg) translate(6px, 6px);
}

.mobile-menu-toggle.is-active span:nth-child(2) {
  opacity: 0;
}

.mobile-menu-toggle.is-active span:nth-child(3) {
  transform: rotate(-45deg) translate(6px, -6px);
}

/* 小屏适配 */
@media (max-width: 1200px) {
  .main-nav ul { gap:40px; }
  .auth-buttons { gap:12px; }
  .auth-btn { padding:6px 16px; font-size:13px; }
}
@media (max-width: 900px) {
  .main-nav ul { gap:28px; }
  .auth-buttons { gap:8px; }
  .auth-btn { padding:5px 12px; font-size:12px; }
}
@media (max-width: 680px) {
  .brand-slogan { display:none; }
  .nav-inner { height:64px; padding:0 20px; display:flex; align-items:center; justify-content:space-between; }
  .mobile-menu-toggle { display:flex; }
  .main-nav { 
  position:fixed; 
  top:64px; 
  left:0; 
  right:0; 
  background:rgba(255,255,255,0.98); 
  backdrop-filter:saturate(180%) blur(12px); 
  flex-direction:column; 
  padding:20px; 
  transform:translateY(-100%); 
  opacity:0; 
  transition:all 0.3s ease; 
  box-shadow:0 4px 12px rgba(0,0,0,0.1);
  z-index: 999;
}
  .main-nav.mobile-nav-open { 
    transform:translateY(0); 
    opacity:1; 
  }
  .main-nav ul { 
    flex-direction:column; 
    gap:0; 
    width:100%;
  }
  .main-nav li { 
    width:100%;
    border-bottom:1px solid rgba(0,0,0,0.05);
  }
  .main-nav li:last-child { 
    border-bottom:none;
  }
 .main-nav a { 
  display:block; 
  padding:16px 0; 
  font-size:16px; 
  text-align:center;
  color: #304156;
}
.header--transparent .main-nav a { color: #fff; }
  .main-nav a::after { 
    display:none;
  }
}

@media (min-width: 1800px) {
  .nav-inner { max-width:1920px; margin:0 auto; }
  .main-nav ul { gap:80px; }
}
</style>